module.exports = __webpack_public_path__ + "img/logo_bridge_africa.f9054072.png";